<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { buildMeta } from '~~/utils/meta-builder'

// shadcn/vue components
import { Card, CardHeader, CardContent } from '@/components/ui/card'

const { t } = useI18n()
const localePath = useLocalePath()

useHead(buildMeta({ key: 'community-guidelines', follow: true }))

const rules = [
  {
    key: 'rule_1',
    icon: "🙌",
    titleKey: 'community.rules.rule_1.title',
    bodyKey: 'community.rules.rule_1.body',
  },
  {
    key: 'rule_2',
    icon: "🧡",
    titleKey: 'community.rules.rule_2.title',
    bodyKey: 'community.rules.rule_2.body',
  },
  {
    key: 'rule_3',
    icon: "🤫",
    titleKey: 'community.rules.rule_3.title',
    bodyKey: 'community.rules.rule_3.body',
  },
  {
    key: 'rule_4',
    icon: "🚫",
    titleKey: 'community.rules.rule_4.title',
    bodyKey: 'community.rules.rule_4.body',
  },
]

</script>

<template>
  <div class="bg-background">
    <div class="container mx-auto px-4 py-10 md:py-16 flex justify-center">
      <Card class="w-full max-w-2xl shadow-lg border border-border">
        <CardHeader class="space-y-3">
          
          <h1 class="text-2xl md:text-3xl font-semibold whitespace-pre-line">
            <!-- Headline mit Zeilenumbruch aus i18n -->
            <span
              v-for="(line, index) in t('community.rules.headline').split('\n')"
              :key="index"
              class="block"
            >
              {{ line }}
            </span>
          </h1>

          <p class="text-sm md:text-base text-muted-foreground whitespace-pre-line">
            <!-- Lead-Text mit Zeilenumbruch -->
            <span
              v-for="(line, index) in t('community.rules.lead').split('\n')"
              :key="index"
              class="block"
            >
              {{ line }}
            </span>
          </p>
        </CardHeader>

        <CardContent class="space-y-6">
          <ul class="space-y-4">
            <li
              v-for="rule in rules"
              :key="rule.key"
              class="rounded-xl border border-border bg-muted/40 p-4"
            >
            <div class="flex flex-row">
              <div class="text-3xl mr-4">
                {{ rule.icon }}
              </div>
              <div class="flex flex-col">
                <h3 class="font-semibold mb-1">
                {{ t(rule.titleKey) }}
              </h3>
              <p class="text-sm text-muted-foreground">
                {{ t(rule.bodyKey) }}
              </p>
              </div>
              
            </div>
             
            </li>
          </ul>

          <p class="text-xs md:text-sm text-muted-foreground my-4">
            {{ t('community.rules.note') }}
          </p>

          <NuxtLink :to="localePath('/privacy-community')"
              class="w-full font-semibold text-primary-500"
            >
              {{ t('privacy.community.moreLink') }}
           
          </NuxtLink>

        </CardContent>
      </Card>
    </div>
    <div class="bg-white overflow-hidden">
			<Footer/>
		</div>
  </div>
</template>
